




























import {Component, Vue, Prop} from 'vue-property-decorator';

@Component(
  {
    name: 'catalog-product-price'
  }
)

export default class extends Vue {
  @Prop() private readonly position: string;

  private get totalPrices(): number {
    return this.$store.getters['CatalogProduct/totalPrices'];
  }

  private get startingPrice(): number {
    return this.$store.getters['CatalogHelper/getStartingPrice'];
  }

  private get configurationSteps(): object {
    return this.$store.getters['CatalogConfigurator/getConfigurationSteps'];
  }

  private get configuratorPrice(): number {
    if (this.configurationSteps['summary']) {
      return this.configurationSteps['summary']['ActionPrice'] || 0;
    }

    return 0;
  }

  private get originalPrice(): number {
    if (this.configurationSteps['summary']) {
      return this.configurationSteps['summary']['Price'] || 0;
    }

    return 0;
  }

  private get productType(): string {
    return this.$store.getters['CatalogHelper/getProductType'];
  }

  private get fromPrices(): number {
    return this.$store.getters['CatalogGroupedProduct/fromPrices'];
  }
}
